import React, { useState } from 'react';
import { Save, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const SaveBrainButton = ({ token, getPayload, brainId, onSaved }) => {
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${API_URL}/api/demo-brains`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ ...getPayload(), id: brainId || undefined }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Failed to save');
      onSaved(data);
      toast.success(brainId ? 'Saved brain updated' : 'Brain saved for next time');
    } catch (e) {
      toast.error(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Button
      type="button"
      size="sm"
      onClick={save}
      disabled={saving}
      className="bg-white border border-blue-300 text-blue-700 hover:bg-blue-50"
      data-testid="save-brain-btn"
    >
      {saving ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Save className="w-4 h-4 mr-1" />}
      {brainId ? 'Update Saved Brain' : 'Save Brain'}
    </Button>
  );
};
